import { render, staticRenderFns } from "./CouponPage2022_2.vue?vue&type=template&id=cdaebdc6&scoped=true&"
import script from "./CouponPage2022_2.vue?vue&type=script&lang=ts&"
export * from "./CouponPage2022_2.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPage2022_2.vue?vue&type=style&index=0&id=cdaebdc6&prod&lang=scss&scoped=true&"
import style1 from "./CouponPage2022_2.vue?vue&type=style&index=1&id=cdaebdc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdaebdc6",
  null
  
)

export default component.exports